import { useAppSelector } from "../../../../redux/hooks";
import { CooperativeSecurity } from "./cooperative";
import { MemberSecurity } from "./member";

export const Security = () => {
  const { profile } = useAppSelector((state) => {
    return state?.auth;
  });

  return profile?.type === "cooperative" ? (
    <CooperativeSecurity />
  ) : (
    <MemberSecurity />
  );
};
